import * as dbInspectionTemplates from 'serviceWorker/db/inspectionTemplates/inspectionTemplates';
import type { InspectionTemplateEntity } from 'serviceWorker/repository/inspectionTemplate/entity';
import { inspectionTemplateEntityToModel } from 'serviceWorker/repository/inspectionTemplate/inspectionTemplateEntityToModel';
import { getCurrentUsers } from 'serviceWorker/services/users/getUsers';
import type { InspectionTemplateModel } from 'shared/domain/template/inspectionTemplateModel';

/** Users are read as stored, never waited for: a read must not block on another entity's download. */
async function toTemplateModels(entities: InspectionTemplateEntity[]): Promise<InspectionTemplateModel[]> {
  const users = await getCurrentUsers();
  return entities.map((entity) => inspectionTemplateEntityToModel(entity, users));
}

/** Every stored template (archived included) as models, without waiting for a download. */
export async function readInspectionTemplateModels(): Promise<InspectionTemplateModel[]> {
  return toTemplateModels(await dbInspectionTemplates.get());
}

/** One stored template, archived ones included; `undefined` when it is not stored. */
export async function readStoredInspectionTemplate(id: string): Promise<InspectionTemplateModel | undefined> {
  const entity = await dbInspectionTemplates.getOne(id);
  if (!entity) {
    return undefined;
  }
  const [template] = await toTemplateModels([entity]);
  return template;
}
